enum DisplayNames {
  Collapse = 'Collapse',
  Fade = 'Fade',
  ScaleFade = 'ScaleFade',
  Slide = 'Slide',
  SlideFade = 'SlideFade'
}

export default DisplayNames;
